export type Stage = 'ide' | 'dev' | 'test' | 'prod';

// FNP-957: this was annotated `: Stage` while reading a value that can be
// undefined (any context without VITE_STAGE set — vitest, most notably). The
// annotation asserted a guarantee the value did not have, so `billingAPI[stage]`
// typechecked and then returned undefined at runtime, and BillingApiClient threw
// while being imported. Falling back keeps the type honest and stops a missing
// env var from taking down module loading.
const configured = import.meta.env.VITE_STAGE as Stage | undefined;

export const stage: Stage = configured ?? 'ide';
